import { authHeader } from "../../../auth";

export default {
    name: "Design Processes",
    components: {
    },
    data() {
        return {
            setURL: this.$serverURL + this.$api.designProcesses.list,
            singleData: {},
            title: "",
            description: "",
            photo: "",
            previewImage: '',
            updatePreviewImage: ''
        }
    },
    async created() {
        document.title = "Platinum Landscape - Design Processes";
        await this.getDataList(this.setURL);
        var scripts = [
            "/core/assets/plugins/datatable/js/jquery.dataTables.min.js",
            "/core/assets/plugins/datatable/js/dataTables.bootstrap5.min.js",
            "/core/assets/js/table-datatable.js"
        ];
        scripts.forEach(script => {
            let tag = document.createElement("script");
            tag.setAttribute("src", script);
            document.head.appendChild(tag);
        });

        let style = document.createElement('link');
        style.type = "text/css";
        style.rel = "stylesheet";
        style.href = '/core/assets/plugins/datatable/css/dataTables.bootstrap5.min.css';
        document.head.appendChild(style);
    },
    methods: {
        uploadFeaturedImage: function (event) {
            this.photo = event.target.files[0];
            let input = this.$refs.blockImage;
            let file = input.files;
            if (file && file[0]) {
                let reader = new FileReader();
                reader.onload = e => {
                    this.previewImage = e.target.result;
                }
                reader.readAsDataURL(file[0])
            }
        },
        updateFeaturedImage: function (event) {
            this.updateImage = event.target.files[0];
            let input = this.$refs.blockUpdateImage;
            let file = input.files;
            if (file && file[0]) {
                let reader = new FileReader();
                reader.onload = e => {
                    this.updatePreviewImage = e.target.result
                }
                reader.readAsDataURL(file[0])
            }
        },
        addData: async function () {
            if (!this.title) {
                this.$swal.fire({
                    icon: "error",
                    text: "Please enter title!"
                });
            } else if (!this.description) {
                this.$swal.fire({
                    icon: "error",
                    text: "Please enter description!"
                });
            } else if (!this.photo) {
                this.$swal.fire({
                    icon: "error",
                    text: "Please enter image!"
                });
            }
            else {
                let formData = new FormData();
                formData.append('title', this.title);
                formData.append('description', this.description);
                formData.append('photo', this.photo);
                let config = {
                    method: "POST",
                    url: this.setURL,
                    data: formData,
                    headers: {
                        "Authorization": authHeader(),
                        "Content-Type": "multipart/form-data",
                    }
                };
                await this.postDataToBackend(config);
                this.title = '';
                this.description = '';
                this.photo = '';
                this.$refs.blockImage.value = null;
                this.previewImage = '';
                await this.getDataList(this.setURL);

                window.$("#addModal").modal('hide');
            }
        },
        editData: async function (data) {
            this.singleData = {...data};
        },
        updateData: async function () {
            if (!this.singleData.title) {
                this.$swal.fire({
                    icon: "error",
                    text: "Please enter title!"
                });
            } else if (!this.singleData.description) {
                this.$swal.fire({
                    icon: "error",
                    text: "Please enter description!"
                });
            } else if (!this.singleData.photo) {
                this.$swal.fire({
                    icon: "error",
                    text: "Please enter image!"
                });
            }
            else {
                let formData = new FormData();
                formData.append('title', this.singleData.title);
                formData.append('description', this.singleData.description);
                formData.append('photo', this.updateImage ? this.updateImage : this.singleData.photo);
                let config = {
                    method: "PATCH",
                    url: `${this.setURL}/${this.singleData._id}`,
                    data: formData,
                    headers: {
                        "Authorization": authHeader(),
                        "Content-Type": "multipart/form-data",
                    }
                };
                await this.updateDataToBackend(config);
                this.$refs.blockUpdateImage.value = null;
                this.singleData = {};
                this.updatePreviewImage = '';
                this.previewImage = '';
                await this.getDataList(this.setURL);
                window.$("#editModal").modal('hide');
            }
        },
        deleteData: function (id) {
            this.$swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    if (result.isConfirmed) {
                        try {
                            let config = {
                                method: 'DELETE',
                                url: `${this.setURL}/${id}`,
                                headers: {
                                    "Authorization": authHeader(),
                                }
                            }
                            await this.deleteDataToBackend(config);
                            await this.getDataList(this.setURL);

                        } catch (error) {
                            this.$swal.fire({
                                icon: "error",
                                text: "Something went wrong, please try agian later." + error
                            });
                        }
                    }
                }
            })

        }
    }
}